import { FONT, PAPER_SIZE } from '../../../../types/enums';
import utils from '../utils';
import pdfStyles from '../../pdfDocument/pdfStyles';
import { getFontFamily } from '../../utils';
import { JapaneseBadgeElementProps } from '../../japaneseBadgeElement/JapaneseBadgeElement';

export const useJapaneseBadgeElement = (
  personData: JapaneseBadgeElementProps['personData'],
  paperSize: JapaneseBadgeElementProps['paperSize'],
  companyNameTruncated: JapaneseBadgeElementProps['companyNameTruncated']
) => {
  const { isSingleLineName, firstName, lastName, jobTitle } = personData;
  const companyNameFontSize = utils.getAdjustedFontSize({
    str1: companyNameTruncated,
    paperSize,
    initialFontSize: 20,
    additionalMaxWidthLength: -30,
    styles: pdfStyles.name
  });
  const nameFontSize = {
    fontSize: utils.getAdjustedFontSize({
      str1: firstName,
      str2: lastName,
      paperSize,
      initialFontSize: companyNameFontSize,
      additionalMaxWidthLength: -30,
      styles: pdfStyles.name
    })
  };
  const jobTitleFontSize = utils.getAdjustedFontSize({
    str1: jobTitle,
    paperSize,
    initialFontSize: companyNameFontSize,
    additionalMaxWidthLength: -30,
    styles: pdfStyles.name
  });

  const isGreaterMarginRequired = paperSize === PAPER_SIZE.LETTER || paperSize === PAPER_SIZE.A4;

  const getCompanyNameStyles = () => {
    return [
      pdfStyles.company,
      { fontSize: companyNameFontSize },
      getFontFamily(companyNameTruncated, { fallbackFont: FONT.HELVETICA_BOLD }),
      {
        marginTop: (isGreaterMarginRequired || isSingleLineName || paperSize === PAPER_SIZE.W298_X_100)  ? 15 : 5
      }
    ];
  };

  const getJobTitleStyles = () => {
    return { ...getFontFamily(jobTitle, { fallbackFont: FONT.HELVETICA }),
      marginTop: (isGreaterMarginRequired || isSingleLineName || paperSize === PAPER_SIZE.W298_X_100)  ? 15 : 5};
  };

  const getLastNameStyles = () => {
    return {
      ...getFontFamily(lastName, { fallbackFont: FONT.HELVETICA }),
      marginTop: isGreaterMarginRequired || isSingleLineName ? 10 : 0
    };
  };

  const getFirstNameStyles = () => {
    return [pdfStyles.name, nameFontSize, getFontFamily(firstName, { fallbackFont: FONT.HELVETICA }), { marginTop: isGreaterMarginRequired || isSingleLineName ? 10 : 0 }];
  };

  const getQrCodeStyles = () => {
    const qrCodeSide = 100;
    let marginTop = isGreaterMarginRequired ? 20 : 0;
    if(!isSingleLineName) {
      marginTop = 0;
    }

    return {
      maxHeight: qrCodeSide,
      maxWidth: qrCodeSide,
      marginBottom: 5,
      marginTop
    };
  };

  const getIconsContainerStyles = () => {
    let marginTop = 47;
    if(paperSize === PAPER_SIZE.FOUR_X_TEN_INCH || paperSize === PAPER_SIZE.FOUR_X_FIVE_INCH || paperSize === PAPER_SIZE.W298_X_100) {
      marginTop = 34;
    }
    if(paperSize === PAPER_SIZE.A4) {
      marginTop = 38;
    }
    if (paperSize === PAPER_SIZE.LETTER) {
      marginTop = 28;
    }
    return { marginTop };
  };

  const getBadgeIdStyles = () => {
    return [pdfStyles.id, {
      marginBottom: 0
    }];
  };

  return {
    getCompanyNameStyles,
    nameFontSize,
    getJobTitleStyles,
    getIconsContainerStyles,
    getBadgeIdStyles,
    getQrCodeStyles,
    getFirstNameStyles,
    getLastNameStyles,
    jobTitleFontSize
  };
};
